import type { NotificationPreferencesDto } from '../api/notificationTypes';
import { endpoints } from '../api/sharedEndpoints';

export interface NotificationRepository {
  getPreferences(): Promise<NotificationPreferencesDto>;
  setAll(params: { enabled: boolean }): Promise<NotificationPreferencesDto>;
  setCategory(params: { category: string; enabled: boolean }): Promise<NotificationPreferencesDto>;
  setType(params: { type: string; enabled: boolean }): Promise<NotificationPreferencesDto>;
}

export class ApiNotificationRepository implements NotificationRepository {
  getPreferences() {
    return endpoints.getNotificationPreferences();
  }

  setAll(params: { enabled: boolean }) {
    return endpoints.setAllNotifications(params.enabled);
  }

  setCategory(params: { category: string; enabled: boolean }) {
    return endpoints.setNotificationCategory(params.category, params.enabled);
  }

  setType(params: { type: string; enabled: boolean }) {
    return endpoints.setNotificationType(params.type, params.enabled);
  }
}
